import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import { ACTIONS } from 'part11/actions/userBulkAdd';

export function loadUserBinders(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_LOAD) {
        return state;
    }

    const result = { ...state };
    const { data } = action.payload;

    const userBinders = {
        ...result.userBinders,
        allData: data,
        isLoading: false
    };
    lodash.set(result, 'userBinders', userBinders);
    return result;
}

export function addUserToBinders(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDERS) {
        return state;
    }
    //update the data of the users by adding the added data set
    const { data } = action.payload;

    const result = {
        ...state
    };

    const existingData = lodash.get(result, 'userBinders.existingData', []);

    const updatedExistingData = [...existingData, ...data];
    const nonSelectedBinders = lodash.differenceBy(data, existingData, 'id');

    const userBinders = {
        ...result.userBinders,
        existingData: updatedExistingData,
        allData: nonSelectedBinders,
        isLoading: false,
        showModal: false
    };

    lodash.set(result, 'addUserToBinders.isLoading', false);
    lodash.set(result, 'userBinders', userBinders);
    return result;
}

export function addUserToBindersRequest(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDERS_REQUEST) {
        return state;
    }

    const result = {
        ...state
    };

    lodash.set(result, 'addUserToBinders.isLoading', true);
    return result;
}

export function addUserToBindersSuccess(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDERS_SUCCESS) {
        return state;
    }
    const result = {
        ...state
    };
    lodash.set(result, 'addUserToBinders.isLoading', false);
    return result;
}

export function addUserToBindersFailure(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDERS_FAILURE) {
        return state;
    }

    if (!action.payload || !action.payload.error) {
        return state;
    }

    const result = {
        ...state
    };

    lodash.set(result, 'addUserToBinders.isLoading', false);
    lodash.set(result, 'addUserToBinders.error', { isPresent: true, message: action.payload.error });

    return result;
}

export function loadingUserBinders(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_LOADING) {
        return state;
    }

    return {
        ...state,
        userBinders: {
            ...state.userBinders,
            isLoading: true,
        },
    };
}

export function loadedUserBinders(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_LOADED) {
        return state;
    }

    return {
        ...state,
        userBinders: {
            ...state.userBinders,
            isLoading: false,
        },
    };
}

export function resetUserBinders(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_RESET) {
        return state;
    }

    return {
        ...state,
        userBinders: {
            ...state.userBinders,
            allData: undefined
        }
    };
}

export function setSelectedBinders(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_SELECTED) {
        return state;
    }
    const { selectedBinderIds } = action.payload;
    return {
        ...state,
        userBinders: {
            ...state.userBinders,
            selectedBinderIds
        },
    };
}

export function setRowChecked(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_ROW_CHECKED) {
        return state;
    }
    const { data } = action.payload;
    const allData = lodash.get(state, 'userBinders.allData', []);
    const selectedIds = lodash.get(state, 'userBinders.selectedBinderIds', []);
    const isChecked = data.tableData.checked ? false: true;
    let resultantSelectedIds = [];
    if(isChecked) {
        resultantSelectedIds = [...selectedIds, data.id];
    }else {
        resultantSelectedIds = selectedIds.filter(itemId => itemId !== data.id);
    }
    const modifiedAllData = allData.map(item => {
        if(item.id === data.id) {
            return {
                ...data,
                tableData: {
                    ...data.tableData,
                    checked: item.tableData.checked ? undefined : true
                }
            };
        }
        return item;
    });

    return {
        ...state,
        userBinders: {
            ...state.userBinders,
            allData: modifiedAllData,
            selectedBinderIds: resultantSelectedIds
        },
    };
}

export function setShowModal(state, action) {
    if (!action || action.type !== ACTIONS.USER_BINDERS_MODAL_SHOW) {
        return state;
    }
    const { show } = action.payload;
    return {
        ...state,
        userBinders: {
            ...state.userBinders,
            showModal: show || false
        },
    };
}

export function addUserToBinderAsAdmin(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDER_AS_ADMIN) {
        return state;
    }
    const { data } = action.payload;
    const result = { ...state };

    const existingData = lodash.get(result, 'allUserBinders.existingData', []);
    const newBinders = data.map((b) => ({
        id: b.id,
        name: b.name,
        principalInvestigator: b.principalInvestigator,
        site: b.site,
        studyId: b.studyId,
        studyUserType: b.studyUserType,
    }));

    lodash.set(result, 'allUserBinders.existingData', [...existingData, ...newBinders]);
    lodash.set(result, 'addUserToBinders.isLoading', false);
    lodash.set(result, 'userBinders.showModal', false);
    lodash.set(result, 'userBinders.allData', []);
    lodash.set(result, 'userBinders.selectedBinderIds', []);
    return result;
}

export function addUserToBinderAsAdminRequest(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDER_AS_ADMIN_REQUEST) {
        return state;
    }
    const result = { ...state };
    lodash.set(result, 'addUserToBinders.isLoading', true);
    return result;
}

export function addUserToBinderAsAdminFailure(state, action) {
    if (!action || action.type !== ACTIONS.ADD_USER_TO_BINDER_AS_ADMIN_FAILURE) {
        return state;
    }
    const result = { ...state };
    lodash.set(result, 'addUserToBinders.isLoading', false);
    return result;
}

export default composeReducers(
    loadingUserBinders,
    loadedUserBinders,
    loadUserBinders,
    resetUserBinders,
    addUserToBinders,
    addUserToBindersRequest,
    addUserToBindersSuccess,
    addUserToBindersFailure,
    addUserToBinderAsAdmin,
    addUserToBinderAsAdminRequest,
    addUserToBinderAsAdminFailure,
    setShowModal,
    setSelectedBinders,
    setRowChecked,
);